<template>
    <div class="has-text-centered">
        <div class="app-block p-md">
            <div>
                {{ $t('candidate.fees.bank_transfer.1') }} {{ school.application_fees }} {{ school.fees_currency }}, {{ $t('candidate.fees.bank_transfer.2') }} :
            </div>
            <div class="p-md">
                <a href="/docs/RIB-DiderotEducation.pdf" target="_blank">
                    <i class="fa fa-file-pdf-o fa-3x" aria-hidden="true"></i></a>
            </div>
            <div>{{ $t('candidate.fees.bank_transfer.instruction') }} :</div>
            <strong>{{ candidate.first_name }} {{ candidate.last_name }} - {{ application.choices[0].training_name }} -
                {{ application.choices[0].campus_name }}</strong>

            <hr>

            <div class="has-text-centered">
                <transition name="slide-fade">
                    <div class="has-text-danger">{{ errorMsg }}</div>
                </transition>
                <button :class="'button-valid button ' + isLoading" @click="send">{{ $t('candidate.fees.bank_transfer.button') }} </button>
            </div>


        </div>
    </div>

</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default {
        data () {
            return {
                isLoading: '',
                errorMsg: ''
            }
        },
        props: {
            school: { type: Object },
            candidate: { type: Object }
        },
        computed: {
            ...mapGetters({
                status: 'candidate/getStatus'
            }),
            application () {
                return this.candidate.applications
            },
        },
        methods: {
            ...mapActions({
                setPayment: 'candidate/savePaymentMode'
            }),
            toggleLoading: function () {
                this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
            },
            send: function () {
                this.toggleLoading()
                const payment = {}
                payment.app_id = this.application.id
                payment.mode = 'BANK-TRANSFER'
                this.setPayment(payment).then((result) => {
                    if (this.status === 200) {
                        this.toggleLoading()
                        this.application.payment_mode = 'BANK-TRANSFER'
                        this.application.fees_complete = 1
                        this.$emit('send')
                    } else if (this.status === 403) {
                        this.toggleLoading()
                        this.$emit('notAuthenticated')
                    } else {
                        this.toggleLoading()
                        this.errorMsg = this.$t('candidate.general.unknown')
                    }
                }).catch(() => {
                    this.toggleLoading()
                    this.errorMsg = this.$t('candidate.general.unknown')
                })
            }
        }

    }
</script>
